import styled from 'styled-components';

function ThematicAreaItem({ title, count }) {
  return (
    <StyledItem>
      <span className="dash-cat-name">
        <img
          src="https://lisa.mofaga.gov.np/backend/storage/categories/5febc24decac6.svg"
          className="cat-icon"
          alt="cat-icon"
        />
        <div className="name">{title}</div>
        <svg className="CircularProgressbar " viewBox="0 0 100 100">
          <path
            className="CircularProgressbar-trail"
            d="
M 50,50
m 0,-46
a 46,46 0 1 1 0,92
a 46,46 0 1 1 0,-92
"
            strokeWidth="8"
            fillOpacity="0"
            style={{ strokeDasharray: '289.027px, 289.027px', strokeDashoffset: 0 }}></path>
          <path
            className="CircularProgressbar-path"
            d="
M 50,50
m 0,-46
a 46,46 0 1 1 0,92
a 46,46 0 1 1 0,-92
"
            strokeWidth="8"
            fillOpacity="0"
            style={{
              stroke: ' rgb(68, 155, 189)',
              strokeDasharray: `290px, 290px`,
              strokeDashoffset: '0px'
            }}></path>
          <text
            className="CircularProgressbar-text"
            x="50"
            y="50"
            style={{ fill: 'rgb(130, 147, 0)', fontSize: ' 28px' }}>
            {count}
          </text>
        </svg>
      </span>
    </StyledItem>
  );
}

export default ThematicAreaItem;

const StyledItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  img,
  svg {
    vertical-align: middle;
  }
  .dash-cat-name {
    width: 90% !important;
    display: flex;
    justify-content: flex-start;
    height: 48px;
    padding: 10px;
    flex: 1 1;
    border-radius: 12px;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 10%);
    background-color: #ececec;
    margin: 5px 0;
    .cat-icon {
      margin-right: 12px;
    }
    .name {
      font-size: 16px;
      text-align: left;
      flex: 3 1;
    }
    .CircularProgressbar {
      height: 45px;
      margin-top: -7px;
      display: ;
    }
    .CircularProgressbar-text {
      font-weight: bold;
      color: #333;
      backgroundcolor: transparent;
      dominant-baseline: middle;
      text-anchor: middle;
    }
  }
`;
